import { Link } from "react-router-dom";

function BaseNavBar(props) {
    return (
        <div className="header">
            <div className="container">
                <div className="row">
                    <div className="col-xl-2 col-lg-2 col-md-2 col-sm-3 col logo_section">
                        <div className="full">
                            <div className="center-desk">
                                <div className="logo">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-10 col-lg-10 col-md-10 col-sm-9">
                        <div className="menu-area">
                            <div className="limit-box">
                                <nav className="main-menu">
                                    <ul className="menu-area-main">
                                        <li className={props.active=='home' ? 'active' : ''}><Link to={"/"+props.match.params.siteid+"/"}>Home</Link> </li>
                                        <li className={props.active=='download' ? 'active' : ''}><Link to={"/"+props.match.params.siteid+"/pages/download"}>Download</Link></li>
                                        <li className={props.active=='about' ? 'active' : ''}><Link to={"/"+props.match.params.siteid+"/pages/about"}>About</Link></li>
                                        <li className={props.active=='privacypolicy' ? 'active' : ''}><Link to={"/"+props.match.params.siteid+"/pages/privacy-policy.html"}>Privacy Policy</Link></li>
                                        <li className={props.active=='support' ? 'active' : ''}><Link to={"/"+props.match.params.siteid+"/pages/support.html"}>Support</Link></li>
                                    </ul>
                                </nav>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default BaseNavBar;
